// Single source of truth for "how bad is this vehicle/asset's Make Ready
// status" - shared between the operative search page and the governance
// overview so the two can't drift on what counts as expired/missing/etc.
export const SEVERITY = {
  expired: { label: 'Expired', color: 'anRed', hex: '#E32525', rank: 0 },
  missing: { label: 'Missing Items', color: 'anPurple', hex: '#85276A', rank: 1 },
  expiringSoon: {
    label: 'Expiring Soon',
    color: 'anOrange',
    hex: '#F28B1F',
    rank: 2,
  },
  neverChecked: {
    label: 'Never Checked',
    color: 'anMainBlue',
    hex: '#268EBB',
    rank: 3,
  },
  good: { label: 'Good', color: 'anGreen', hex: '#00964C', rank: 4 },
  // Not a health state: the vehicle/asset has no load list, so it has never
  // been checked and can't be. Only produced by the untracked feed, never by
  // getSeverityLevel.
  untracked: { label: 'Untracked', color: 'anMuted', hex: '#94A3B8', rank: 5 },
}

export const SEVERITY_ORDER = [
  'expired',
  'missing',
  'expiringSoon',
  'neverChecked',
  'good',
  'untracked',
]

export const getSeverityLevel = ({
  hasExpiredItems,
  hasMissingItems,
  expiringSoonCount,
  lastCheckedAt,
}) => {
  if (hasExpiredItems) return 'expired'
  if (hasMissingItems) return 'missing'
  if (expiringSoonCount > 0) return 'expiringSoon'
  if (lastCheckedAt) return 'good'
  return 'neverChecked'
}

export const getSeverityColor = (fields) => SEVERITY[getSeverityLevel(fields)].color
